import React from 'react'
import PropTypes from 'prop-types'
import { Box, Image, Badge, Container } from '@chakra-ui/react'
import { withTranslation } from 'i18n'
import HTMLSanitizer from 'lib/html-sanitizer'

const LifeCycleLayoutTwo = ({ data, meta, theme, t, dataTestId }) => {
  if (!data.length) {
    return false
  }

  const titleNode = () => {
    if (!meta.title) return false

    return (
      <Box
        as='h2'
        color={theme.sectionTitleColor}
        fontFamily='heading'
        fontSize='sectionTitle'
        fontWeight='heading'
        mb={4}
      >
        {meta.title}
      </Box>
    )
  }

  const constructCurrentStage = (currentStage, index) => {
    if (currentStage === index) {
      return t('editor:editor.current')
    } else if (currentStage < index) {
      return t('editor:editor.upcoming')
    } else {
      return t('editor:editor.finished')
    }
  }

  return (
    <Box
      bg={theme.backgroundColor}
      px={[2, 4, 8, 16]}
      data-testid={dataTestId}
    >
      <Box bg={theme.backgroundColor} py={8} px={[4, 4, 0, 0]}>
        <Container maxW='container.lg' mx='auto' px={0}>
          {titleNode()}
          <Container maxW='container.sm' mx='auto' px={0}>
            {data.map((stage, index) => {
              return (
                <Box
                  display='flex'
                  key={index}
                  mb={12}
                >
                  <Box
                    boxShadow='site'
                    bg={theme.cardBackgroundColor}
                    key={index}
                    mr={4}
                    overflow='hidden'
                    p={4}
                    rounded='site'
                    w='full'
                  >
                    <Box
                      color={theme.textColor}
                      fontFamily='heading'
                      fontWeight='heading'
                      fontSize='heading'
                      mb={0}
                    >
                      {stage.name}
                    </Box>
                    <Badge
                      fontFamily='body'
                      fontSize='body'
                      rounded='site'
                      variant='solid'
                      className='ehq-text-gray-8 ehq-bg-gray-4 ehq-px-1 ehq-py-1 ehq-leading-4 ehq-font-normal'
                    >
                      {constructCurrentStage(meta.currentStage, index)}
                    </Badge>
                    <Box
                      as='p'
                      color={theme.textColor}
                      fontFamily='body'
                      fontWeight='body'
                      fontSize='body'
                      mt={2}
                    >
                      {HTMLSanitizer(stage.description)}
                    </Box>
                  </Box>
                  <Box w={16}>
                    <Image
                      alt=''
                      p={1}
                      rounded='site'
                      src={meta.icon}
                      boxSize={12}
                    />
                  </Box>
                </Box>
              )
            })}
          </Container>
        </Container>
      </Box>
    </Box>
  )
}

LifeCycleLayoutTwo.propTypes = {
  data: PropTypes.array,
  meta: PropTypes.object,
  theme: PropTypes.object,
  dataTestId: PropTypes.string.isRequired
}

export default withTranslation(['editor'])(LifeCycleLayoutTwo)
